const HEADER_ROWS = ['Assets', 'Liabilities', "Shareholders' Equity"];

export default HEADER_ROWS;
